import React from 'react';

import { Card } from '@ergeon/core-components';

const SalesToolkit = () => {
  return (
    <Card className="flex-1 overflow-hidden first-letter:overflow-hidden" flavor="base" zIndex="1">
      <iframe
        allowFullScreen
        className="flex-1 w-full"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
        src="https://lookerstudio.google.com/embed/reporting/e8e76080-31c0-4296-927f-49a3c28cbae2/page/p_2uzxi16sqd"
        title="Sales Toolkit" />
    </Card>
  );
};

export default SalesToolkit;
